import { AllergensKey, ProductAllergens } from '@oolio-group/domain';

/** Unknown codes render verbatim; the vocabulary can outrun the client enum. */
export const formatAllergenName = (code: AllergensKey): string =>
  ProductAllergens[code] ?? String(code);

export const formatAllergenList = (codes?: AllergensKey[]): string =>
  (codes ?? []).map(formatAllergenName).join(', ');

/** Undefined for an empty set, so the Mustache block is skipped. */
export const formatAllergenPrintLines = (
  codes?: AllergensKey[],
): string | undefined => {
  if (!codes?.length) return undefined;
  return codes
    .map(code => `**ALLERGY ${formatAllergenName(code).toUpperCase()}**`)
    .join('\n');
};

export const hasAllergens = (codes?: AllergensKey[]): boolean =>
  !!codes?.length;
